import React from 'react';
import { Phone, Award, CheckCircle2 } from 'lucide-react';

const Hero = () => {
  return (
    <section id="accueil" className="relative pt-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
              <Award className="w-4 h-4 mr-2" />
              33 ans d'expérience
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Carreleur professionnel à <span className="text-blue-600">Saint-Julien-sur-Bibost</span>
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Artisan carreleur indépendant avec 33 années d'expérience dans les Monts du Lyonnais. 
              Spécialisé en pose de carrelage pour particuliers et professionnels, Lyon Ouest et communes environnantes.
            </p>

            {/* Key Points */}
            <div className="space-y-3">
              <div className="flex items-start">
                <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Devis gratuit et sans engagement</span>
              </div>
              <div className="flex items-start">
                <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Artisan local, interlocuteur unique</span>
              </div>
              <div className="flex items-start">
                <CheckCircle2 className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" />
                <span className="text-gray-700">Intervention rapide dans un rayon de 50 km</span>
              </div>
            </div>

            {/* CTA Buttons - REMOVED - Site statique */}
            <div className="pt-4">
              <p className="text-gray-600 text-lg">
                Pour toute demande de devis ou information, contactez-nous directement par téléphone ou email.
              </p>
            </div>

            {/* Trust Badge */}
            <div className="pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-500">
                Basé à Saint-Julien-sur-Bibost • Intervention jusqu'à 50 km
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1642678751244-296d18c4cab3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0aWxlJTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY4MjE0NDczfDA&ixlib=rb-4.1.0&q=85"
                alt="Carrelage professionnel de qualité"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900/20 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute bottom-6 left-6 right-6 bg-white rounded-xl shadow-xl p-6">
              <div className="text-center">
                <p className="text-3xl font-bold text-blue-600 mb-2">33 ans</p>
                <p className="text-gray-700 font-medium">
                  Savoir-faire éprouvé depuis 1992
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  Travaux réalisés avec soin et régularité depuis plusieurs décennies
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
